var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isLoading)?_c('div',{staticClass:"spinner"},[_c('font-awesome-icon',{staticClass:"fa-spin",attrs:{"icon":"spinner"}})],1):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }